<script lang="ts">
  export let color: string = "";
  export let vacationPattern: boolean = false;
  export let deadlinePattern: boolean = false;
  export let withBorder: boolean = false;
</script>

<div class="legend-item">
  <div
    class="legend-item-img"
    class:with-border={withBorder}
    class:vacation={vacationPattern}
    class:deadline={deadlinePattern}
    style="background: {color}"
  />
  <span class="legend-item-name"><slot /></span>
</div>

<style lang="scss">
  .legend-item {
    display: flex;
    align-items: center;
    margin-right: 18px;

    @include sm-down {
      align-items: flex-start;
      margin-right: unset;
    }

    &:last-of-type {
      margin-right: unset;
    }
  }

  .legend-item-img {
    &.with-border {
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);
    }
    &.vacation {
      @include stripes-pattern;
    }
    &.deadline {
      @include stripes-deadline-pattern;
    }

    @include sm-down {
      margin-top: 2px;
    }
  }

  .legend-item-name {
    margin-left: 8px;
  }

  .legend-item-img {
    width: 16px;
    height: 16px;
    min-width: 16px;
  }
</style>
